import { useState, useEffect } from "react";
import { getEds } from "../services/newActionServices";
import { useTranslation } from "react-i18next";

export function useEdsOptions({pcd, store, hfb}) {
  const [t] = useTranslation("global")
  const [edsOptions, setEdsOptions] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (pcd && store && hfb) {
      setEdsOptions([])
      setLoading(true)
      getEds({ store: store.id, hfb: hfb.id, PCD: pcd.id })
        .then((response) => {
          const edsOptionFormatted = response.map((eds)=>({label: eds, value: eds}))
          edsOptionFormatted.push({
            value: "all",
            label: t("new-action.all-edsClass"),
          })
          setEdsOptions(edsOptionFormatted)
        })
        .catch((error) => console.error("Error loading eds options:", error))
        .finally(()=>{
          setLoading(false)
        })
    }
  }, [pcd, store, hfb])

  return {
    loading,
    edsOptions,
  }
}
